<template>
  <div class="flex items-center">
    <i class="rounded-4 flag" :class="`flag-${countryFrom.toLowerCase()}`" />
    <strong>{{ amount ? formatMoney(amount, currencyFrom, $lang, 0) : currencyFrom }}</strong>
    <span class="mx-3 font-semibold">➜</span>
    <i class="rounded-4 flag" :class="`flag-${countryTo.toLowerCase()}`" />
    <strong>{{ currencyTo }}</strong>
    <img
      v-if="payout"
      class="icon icon-sm ml-2 my-auto"
      :src="getPaymentIcon(payout.toLowerCase())"
      :alt="payout"
    />
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  countryFrom: string
  countryTo: string
  currencyFrom: string
  currencyTo: string
  amount?: number
  payout?: string
}>()

const { $lang } = useNuxtApp()
</script>
